import CookieConsent from 'react-cookie-consent'
import React from 'react'

import Link from '@material-ui/core/Link'
import { makeStyles } from '@material-ui/core/styles'

import { useLocalStorage } from '../hooks/useLocalStorage/useLocalStorage'

import cookiesPolicyDocument from '../assets/documents/politica-cookies.pdf'
import privacyPolicyDocument from '../assets/documents/politica-privacidade.pdf'
import termsOfUseDocument from '../assets/documents/termos-de-uso.pdf'

const styles = () => ({
  link: {
    color: '#ffffff',
    fontWeight: 'bold',
    textDecoration: 'underline',
  },
})
const useStyles = makeStyles(styles)

export default function ApplicationCookieConsent() {
  const [cookiesConsent, setCookiesConsent] = useLocalStorage(
    'cookiesConsent',
    false,
  )

  const classes = useStyles()

  if (cookiesConsent) {
    return null
  }

  return (
    <CookieConsent
      buttonStyle={{ backgroundColor: '#ffffff' }}
      buttonText="Prosseguir"
      onAccept={() => {
        setCookiesConsent(true)
      }}
      style={{ paddingBottom: 48 }}
    >
      Nós usamos{' '}
      <Link
        className={classes.link}
        href={cookiesPolicyDocument}
        target="_blank"
      >
        Cookies
      </Link>{' '}
      e outras tecnologias semelhantes para melhorar a sua experiência em nossos
      serviços. Ao utilizar nossos serviços, você concorda com tal
      monitoramento. Conheça nossos{' '}
      <Link className={classes.link} href={termsOfUseDocument} target="_blank">
        Termos de Uso
      </Link>{' '}
      e veja a nossa{' '}
      <Link
        className={classes.link}
        href={privacyPolicyDocument}
        target="_blank"
      >
        Política de Privacidade
      </Link>
      .
    </CookieConsent>
  )
}
